"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  [![Run in Postman](https://run.pstmn.io/button.svg)](https://app.getpostman.com/run-collection/614feab5c108d292bffa#?env%5BStacks%20Blockchain%20API%5D=W3sia2V5Ijoic3R4X2FkZHJlc3MiLCJ2YWx1ZSI6IlNUMlRKUkhESE1ZQlE0MTdIRkIwQkRYNDMwVFFBNVBYUlg2NDk1RzFWIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJibG9ja19pZCIsInZhbHVlIjoiMHgiLCJlbmFibGVkIjp0cnVlfSx7ImtleSI6Im9mZnNldCIsInZhbHVlIjoiMCIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoibGltaXRfdHgiLCJ2YWx1ZSI6IjIwMCIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoibGltaXRfYmxvY2siLCJ2YWx1ZSI6IjMwIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJ0eF9pZCIsInZhbHVlIjoiMHg1NDA5MGMxNmE3MDJiNzUzYjQzMTE0ZTg4NGJjMTlhODBhNzk2MzhmZDQ0OWE0MGY4MDY4Y2RmMDAzY2RlNmUwIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJjb250cmFjdF9pZCIsInZhbHVlIjoiU1RKVFhFSlBKUFBWRE5BOUIwNTJOU1JSQkdRQ0ZOS1ZTMTc4VkdIMS5oZWxsb193b3JsZFxuIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJidGNfYWRkcmVzcyIsInZhbHVlIjoiYWJjIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJjb250cmFjdF9hZGRyZXNzIiwidmFsdWUiOiJTVEpUWEVKUEpQUFZETkE5QjA1Mk5TUlJCR1FDRk5LVlMxNzhWR0gxIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJjb250cmFjdF9uYW1lIiwidmFsdWUiOiJoZWxsb193b3JsZCIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoiY29udHJhY3RfbWFwIiwidmFsdWUiOiJzdG9yZSIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoiY29udHJhY3RfbWV0aG9kIiwidmFsdWUiOiJnZXQtdmFsdWUiLCJlbmFibGVkIjp0cnVlfV0=)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaSignatureToJSON = exports.RosettaSignatureFromJSONTyped = exports.RosettaSignatureFromJSON = exports.RosettaSignatureSignatureTypeEnum = void 0;
const _1 = require("./");
/**
* @export
* @enum {string}
*/
var RosettaSignatureSignatureTypeEnum;
(function (RosettaSignatureSignatureTypeEnum) {
    RosettaSignatureSignatureTypeEnum["ecdsa"] = "ecdsa";
    RosettaSignatureSignatureTypeEnum["ecdsa_recovery"] = "ecdsa_recovery";
    RosettaSignatureSignatureTypeEnum["ed25519"] = "ed25519";
    RosettaSignatureSignatureTypeEnum["schnorr_1"] = "schnorr_1";
    RosettaSignatureSignatureTypeEnum["schnorr_poseidon"] = "schnorr_poseidon";
})(RosettaSignatureSignatureTypeEnum = exports.RosettaSignatureSignatureTypeEnum || (exports.RosettaSignatureSignatureTypeEnum = {}));
function RosettaSignatureFromJSON(json) {
    return RosettaSignatureFromJSONTyped(json, false);
}
exports.RosettaSignatureFromJSON = RosettaSignatureFromJSON;
function RosettaSignatureFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'signing_payload': _1.SigningPayloadFromJSON(json['signing_payload']),
        'public_key': _1.RosettaPublicKeyFromJSON(json['public_key']),
        'signature_type': json['signature_type'],
        'hex_bytes': json['hex_bytes'],
    };
}
exports.RosettaSignatureFromJSONTyped = RosettaSignatureFromJSONTyped;
function RosettaSignatureToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'signing_payload': _1.SigningPayloadToJSON(value.signing_payload),
        'public_key': _1.RosettaPublicKeyToJSON(value.public_key),
        'signature_type': value.signature_type,
        'hex_bytes': value.hex_bytes,
    };
}
exports.RosettaSignatureToJSON = RosettaSignatureToJSON;
//# sourceMappingURL=RosettaSignature.js.map